import { Application } from '@hotwired/stimulus'
import { Slideover, Dropdown } from 'tailwindcss-stimulus-components'
import ContentLoader from 'stimulus-content-loader'
import Sortable from 'stimulus-sortable'
import { StreamActions, visit } from '@hotwired/turbo'
import KelvinDataLayer from '../lib/kelvin_data_layer'
import AddressAutocompleteController from './address_autocomplete_controller'

StreamActions.redirect = function () {
  const target = this.target.startsWith('/')
    ? `${window.location.origin}${this.target}`
    : this.target

  if (this.getAttribute('turbo') === 'false') {
    window.location.href = target
  } else {
    visit(target)
  }
}

StreamActions.frame_visit = function () {
  const frame = this.getAttribute('frame')
  const frameObject = document.querySelector(`turbo-frame[id="${frame}"]`)
  if (!frameObject) return

  const action = this.getAttribute('frame_action')
  const options = { frame }
  if (action) options.action = action

  visit(this.getAttribute('url'), options)
}

StreamActions.set_attribute = function () {
  const selector = this.getAttribute('selector')
  const attribute = this.getAttribute('attribute')
  const value = this.getAttribute('value')

  document.querySelectorAll(selector).forEach(element => {
    element.setAttribute(attribute, value)
  })
}

StreamActions.remove_attribute = function () {
  const selector = this.getAttribute('selector')
  const attribute = this.getAttribute('attribute')

  document.querySelectorAll(selector).forEach(element => {
    element.removeAttribute(attribute)
  })
}

StreamActions.kelvin_data_layer_push = function () {
  if (!window.kelvinDataLayer) {
    window.kelvinDataLayer = new KelvinDataLayer()
  }
  const event = JSON.parse(this.getAttribute('value'))
  window.kelvinDataLayer.push(event)
}

StreamActions.refresh_frame = function () {
  const id = this.getAttribute('id')
  const frame = document.querySelector(`turbo-frame[id="${id}"]`)
  if (!frame) return
  if (frame.dataset.suppressRefresh === 'true') return
  frame.reload()
}

StreamActions.replace_title = function () {
  document.title = this.getAttribute('title')
}

const application = Application.start()
application.register('dropdown', Dropdown)
application.register('slideover', Slideover)
application.register('content-loader', ContentLoader)
application.register('sortable', Sortable)
application.register('autocomplete', AddressAutocompleteController)

// Configure Stimulus development experience
application.debug = process.env.NODE_ENV === 'development'
window.Stimulus = application

export { application }
